var globalInterval = {};
var timer;
var globalTime = 0;
globalInterval.set = function (time, callback) {
    if(timer){
        return;
    }
    timer = setInterval(function () {
        time--;
        //consoe.log.log(time);
        globalTime = time;
        if (time === 0) {
            if(callback){
                callback();
            }
            clearInterval(timer);
            timer='';
        }
    }, 1000);
};
globalInterval.clear = function (callback) {
    if(callback){
        callback();
    }
    clearInterval(timer);
    globalTime = 0;
};
globalInterval.getTime=function(){
    return globalTime;
};
export default globalInterval;



// WEBPACK FOOTER //
// ./src/utils/Interval.js